module.exports = __webpack_public_path__ + "img/block3_visits1.0e2c0203.jpg";